$(document).ready(function() {
    // Get the navbar
    var sidebar = document.getElementById('sidebarProjects');
    if(sidebar)
    {
        // Get the offset position of the navbar
        var sticky = sidebar.offsetTop;

        // When the user scrolls the page, execute myFunction 
        window.onscroll = function() {
            sidebarSticky(sidebar, sticky);
        };
    }
});

// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
function sidebarSticky(sidebar, sticky) {
    var width = sidebar.offsetWidth;
    var sidebarShadow = document.getElementById('stickyShadow');

    if (window.pageYOffset >= sticky) {
        sidebar.classList.add('sticky');
        if (!sidebarShadow && $(sidebar).hasClass('active')) {
            $(sidebar).parent().append(
                                '<div id="stickyShadow" style="'+
                                        'width:' + width + 'px;'+
                                        'flex: 0 0 ' + width + 'px;' +
                                '"></div>');
        };
    } else {
        sidebar.classList.remove('sticky');
        if (sidebarShadow) sidebarShadow.remove();
    }
}
window.sidebarSticky = sidebarSticky;


// WEBPACK FOOTER //
// ./resources/js/components/sidebarSticky.js